// removed by extract-text-webpack-plugin
module.exports = {"BreadBottom":"BurgerIngredient__BreadBottom__pgUas","BreadTop":"BurgerIngredient__BreadTop__1qwk-","Seeds1":"BurgerIngredient__Seeds1__1NoR3","Seeds2":"BurgerIngredient__Seeds2__rJjjN","Meat":"BurgerIngredient__Meat__27By3","Cheese":"BurgerIngredient__Cheese__3Xxg-","Lettuce":"BurgerIngredient__Lettuce__2bS1u","Bacon":"BurgerIngredient__Bacon__1FuPv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BurgerIngredients/BurgerIngredient.css
// module id = 140
// module chunks = 0